<ng-container *ngIf="progress">
  <div class="progress-bar background"></div>
  <div class="progress-bar first  branding-accent-light-background" [style.width]="progress.first.value + '%'"></div>
  <div class="progress-bar second branding-accent-normal-background" [style.width]="progress.second.value + '%'"></div>
  <div class="progress-bar third  branding-accent-dark-background" [style.width]="progress.third.value + '%'"></div>
  <div class="progress-numeric">
    <div class="progress-numeric-value">{{progress.first.label | translate:{value:progress.first.value} }}</div>
    <div class="progress-numeric-value">{{progress.second.label | translate:{value:progress.second.value} }}</div>
    <div class="progress-numeric-value">{{progress.third.label | translate:{value:progress.third.value} }}</div>
  </div>
</ng-container>
